import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimelineRefreshService {
  private refreshTrigger$ = new Subject<void>();

  readonly refresh$ = this.refreshTrigger$.asObservable();

  triggerRefresh() {
    this.refreshTrigger$.next();
  }
}
